module.exports = __webpack_public_path__ + "static/media/assigment-interview.359ecafa.svg";